import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class SeasonFilter extends React.Component {
  handleSeasonChange = (selectedOption) => {
    this.props.seasonSet(selectedOption.value);
  }

  componentDidMount() {
    // Only auto-select the first season when nothing is selected yet, so a caller
    // that seeds a default (e.g. the standings page) isn't overridden on mount.
    if (!this.props.allIncluded && this.props.seasons.length > 0 && !this.props.currentSeason) {
      this.handleSeasonChange({ value: this.props.seasons[0].id, label: this.props.seasons[0].name });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.seasons !== this.props.seasons && this.props.seasons.length > 0) {
      if (!this.props.currentSeason || !this.props.seasons.some(s => s.id === this.props.currentSeason)) {
        this.handleSeasonChange({ value: this.props.seasons[0].id, label: this.props.seasons[0].name });
      }
    }
  }

  render() {
    const { t_controls, seasons, allIncluded } = this.props;
    const seasonOptions = seasons.map((s) => ({ value: s.id, label: s.name }));
    allIncluded && seasonOptions.unshift({value: 0, label: t_controls.all_seasons});
    return (
      <li style={{width: '200px'}}>
        <Select
          className="select"
          onChange={this.handleSeasonChange}
          options={seasonOptions}
          value={seasonOptions.find(opt => opt.value === this.props.currentSeason)}
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
      </li>
    );
  }
}

SeasonFilter.propTypes = {
  seasons: PropTypes.array.isRequired,
  seasonSet: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
  currentSeason: PropTypes.number,
  allIncluded: PropTypes.bool.isRequired
};

export default SeasonFilter;
